var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    appId: '',
    datasets: [],
    states: [],
    views: [],
    customLogics: [],
    permissions: [],
    selectedPatches: [],
    contextMenuPosition: null,
};
var dataSlice = createSlice({
    name: 'data',
    initialState: initialState,
    reducers: {
        setAppId: function (state, action) {
            state.appId = action.payload;
        },
        updateDatasets: function (state, action) {
            state.datasets = action.payload;
        },
        updateStates: function (state, action) {
            state.states = action.payload;
        },
        updateViews: function (state, action) {
            state.views = action.payload;
        },
        updateCustomLogics: function (state, action) {
            state.customLogics = action.payload;
        },
        updatePermissions: function (state, action) {
            state.permissions = action.payload;
        },
        setContextMenuPosition: function (state, action) {
            state.contextMenuPosition = action.payload;
        },
    },
});
export var setAppId = (_a = dataSlice.actions, _a.setAppId), updateDatasets = _a.updateDatasets, updateStates = _a.updateStates, updateViews = _a.updateViews, updateCustomLogics = _a.updateCustomLogics, updatePermissions = _a.updatePermissions, setContextMenuPosition = _a.setContextMenuPosition;
export default dataSlice.reducer;
